<template>
    <b-col cols="12" class="filter-form mt-2">
        <b-card>
            <b-card-body>

                <form class="form-sample filter-inner mb-4 p-4">
                    <b-row>
                        <b-col cols="12" class="mt-0">
                            <label for="input-type" class="mb-2"><strong>{{ $translate('activity_types')
                                    }}</strong></label>

                            <multiselect id="input-type" :placeholder="$translate('select_activity_types')"
                                :deselectLabel="deselectLabel" :selectedLabel="selectedLabel" :selectLabel="selectLabel"
                                v-model="typeOptions" :multiple="true" :options="orderTypes" label="name" track-by="id"
                                :close-on-select="false">
                            </multiselect>
                        </b-col>

                        <b-col class="mt-4" md="6" cols="12">
                            <label class="mb-2"><strong> {{ $translate('activity_status') }}</strong></label>
                            <b-form-select id="input-status" v-model="queryForm.status" value-field="id"
                                text-field="name" :options="status">
                                <template #first>
                                    <b-form-select-option :value="null">
                                        {{ $translate('select_status') }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col class="mt-4" md="6" cols="12">
                            <label for="fieldset-role-id" class="mb-3"><strong>{{ $translate('customer_groups')
                                    }}</strong></label>
                            <b-form-select id="input-role-id" v-model="queryForm.customer_group_id" value-field="id"
                                text-field="name" :options="customerGroups">
                                <template #first>
                                    <b-form-select-option :value="null">{{ $translate('select_customer_group')
                                        }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col class="mt-4" md="3" cols="12">
                            <label class="mb-2"><strong> {{ $translate('due_from') }}</strong></label>
                            <div class="filter-date">
                                <b-form-input type="date" id="input-due_from" :max="queryForm.due_to"
                                    v-model="queryForm.due_from" />
                            </div>
                        </b-col>

                        <b-col class="mt-4" md="3" cols="12">
                            <label class="mb-2"><strong> {{ $translate('due_to') }}</strong></label>
                            <div class="filter-date">
                                <b-form-input type="date" id="input-due_to" :min="queryForm.due_from"
                                    v-model="queryForm.due_to" />
                            </div>
                        </b-col>


                        <b-col class="mt-4" md="6" cols="12">
                            <label class="mb-2"><strong> {{ $translate('balance') }}</strong></label>
                            <b-form-input v-model="queryForm.balance"
                                :placeholder="$translate('select_balance')"></b-form-input>
                        </b-col>
                    </b-row>
                </form>
            </b-card-body>
        </b-card>
    </b-col>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    name: 'orders-queryfilters',
    components: {
        Multiselect
    },
    props: [
        'value',
    ],
    data() {
        return {
            queryForm: {
                types: [], status: null, customer_group_id: null, due_to: null, due_from: null, balance: null
            }
        }
    },
    computed: {
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
        status() {
            return [
                { id: 1, name: this.$translate('completed') },
                { id: 2, name: this.$translate('processing') },
                { id: 3, name: this.$translate('pending') },
            ]
        },

        customerGroups() {
            const customerGroups =
                this.$store.state.customerGroups.customer_groups
                || []
            return customerGroups
        },

        orderTypes() {
            return (this.$store.state.orderType.items || []).map(({ id, name }) => ({ id, name }))
        },

        typeOptions: {
            get() {
                const {
                    orderTypes,
                    queryForm: { types }
                } = this
                return (types || []).map(id => orderTypes.find(x => x.id == id))
            },
            set(_items) {
                this.$set(this.queryForm, 'types', (_items || []).map(x => x.id))
            },
        },
    },
    mounted() {
        this.$store.dispatch("orderType/fetchAll");
        this.$store.dispatch('customerGroups/fetchAll')

        const parsedValue = this.value ? JSON.parse(this.value) : {};
        for (const key in this.queryForm) {
            this.$set(this.queryForm, key, parsedValue[key] ?? null)
        }
    },
    watch: {
        queryForm: {
            handler: function (_value) {
                this.$emit("input", JSON.stringify(_value))
            },
            deep: true
        }
    },
    methods: {


    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>
